// Consent Mode v2 helpers — companion to the inline `gtag('consent', 'default', ...)`
// call in public/index.html. This module handles the RUNTIME update flow:
// showing a banner to EEA visitors and letting them accept/reject.
//
// Non-EEA visitors never see the banner because index.html defaults them
// to `granted` on first load.

const STORAGE_KEY = 'cb_consent';

/** Was the visitor detected as inside the EEA on page load? */
export function isEEA() {
  return !!window.__cbIsEEA;
}

/** Current stored decision, or null if the visitor hasn't chosen yet. */
export function getConsent() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** True when we should show the banner: EEA visitor without a stored choice. */
export function shouldShowBanner() {
  return isEEA() && !getConsent();
}

function pushConsentUpdate(decision) {
  const values = decision === 'granted'
    ? { ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted', analytics_storage: 'granted' }
    : { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied' };
  // gtag comes from the inline snippet in index.html.
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', values);
  } else if (window.dataLayer) {
    window.dataLayer.push(['consent', 'update', values]);
  }
}

export function acceptConsent() {
  try { localStorage.setItem(STORAGE_KEY, 'granted'); } catch { /* ignore */ }
  pushConsentUpdate('granted');
}

export function rejectConsent() {
  try { localStorage.setItem(STORAGE_KEY, 'denied'); } catch { /* ignore */ }
  pushConsentUpdate('denied');
}
